import {Datagrid, List, TextField, TextInput} from "react-admin";

const FormsList = (props) => {
    const filters = [<TextInput label='Formlário' source='name' alwaysOn />,]

    return (
        <List
            exporter={false}
            bulkActionButtons={false}
            title={'Formulários de Requisitção'}
            {...props}
            filters={filters}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} sortable={false} />
                <TextField source="description" label={'Descrição'} />
                {/*<ArrayField source={'fields'}>*/}
                {/*    <SingleFieldList linkType={false}><ChipField source={'label'} /></SingleFieldList>*/}
                {/*</ArrayField>*/}
            </Datagrid>
        </List>
    )
}

export default FormsList;